// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    projectId: 'idmxapp',
    appId: '1:596643181372:web:227e54d4d612408ce7a439',
    storageBucket: 'idmxapp.appspot.com',
    apiKey: 'AIzaSyBvHyiSfUCyKHaGfjgkWxQ5oBEO70zo9NM',
    authDomain: 'idmxapp.firebaseapp.com',
    messagingSenderId: '596643181372',
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
